module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-pad-y-1"
  }, [(_vm.contentPage.list.length > 0) ? _c('div', {
    staticClass: "c-page--container c-marg--before-footer u-relative"
  }, [_c('app-title', {
    staticClass: "c-big-title",
    attrs: {
      "logo": _vm.contentGlobal.secondaryLogo,
      "title": _vm.contentPage.title
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "o-list--none"
  }, _vm._l((_vm.contentPage.list), function(team, index) {
    return _c('li', {
      staticClass: "c-team-box o-list__item u-relative"
    }, [_c('div', [_c('div', {
      staticClass: "c-team-logo__bg o-wrapper--valign u-align-center u-marg-x-xxl u-marg-x-auto@md u-marg-b-md@md"
    }, [_c('app-img', {
      staticClass: "u-inline-block u-valign-middle",
      attrs: {
        "src": team.logo,
        "width": "100",
        "alt": team.name
      }
    })], 1)]), _vm._v(" "), _c('div', {
      class: {
        'u-marg-b-xxl': index + 1 < _vm.contentPage.list.length
      }
    }, [_c('abbr', {
      staticClass: "t-text--xl u-block u-color--gray-purple u-hide@md",
      attrs: {
        "title": "team.name"
      },
      domProps: {
        "innerHTML": _vm._s(team.acronym)
      }
    }), _vm._v(" "), _c('h2', {
      staticClass: "c-teams--name u-block t-h u-bold u-uppercase u-marg-b-xs t-text--xxl@md",
      domProps: {
        "innerHTML": _vm._s(team.name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "t-text--md t-lspacing--sm u-line-height--lg u-color--gray-purple u-marg-b-md",
      domProps: {
        "innerHTML": _vm._s(team.description)
      }
    }), _vm._v(" "), (team.observeId !== false) ? _c('app-btn', {
      staticClass: "u-marg-r-xxs u-marg-b-xxs",
      on: {
        "click": function($event) {
          _vm.openModalRegister(team.observeId)
        }
      }
    }, [_c('span', {
      staticClass: "c-register-btn-icon__container u-inline-block"
    }, [_c('img', {
      staticClass: "c-register-btn-icon__img u-absolute u-pos-l u-pos-y-center",
      attrs: {
        "src": require("../../../assets/icon/icon-register--support.png")
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "u-valign-middle",
      domProps: {
        "innerHTML": _vm._s(_vm.contentPage.taxonomy.support)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "u-valign-middle u-bold"
    }, [_vm._v("(" + _vm._s(team.observeCount) + ")")])]) : _vm._e(), _vm._v(" "), _c('app-btn', {
      staticClass: "u-marg-b-xxs",
      attrs: {
        "to": _vm.getTeamUrlBySlug(team.slug)
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.contentPage.taxonomy.more)
      }
    })])], 1)])
  }))], 1) : _c('app-season-coming-soon', {
    staticClass: "c-page--container c-marg--before-footer u-relative"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d1de431"}!./src/scripts/components/page-teams/template.html
// module id = 915
// module chunks = 0